module.exports = __webpack_public_path__ + "img/9788994142678.a30db737.jpg";